@if (servicingFacilityNew) {
  <div>
    <div class="p-field-checkbox-container p-field-checkbox">
      <p-checkbox
        data-test-id="facility-npi-not-found-checkbox"
        [ngModel]="true"
        [binary]="true"
        [disabled]="true"
      ></p-checkbox>
      <label data-test-id="facility-npi-not-found-label"> Facility Not Found </label>
    </div>
    <p-panel header="New Servicing Facility">
      <div class="grid grid-cols-12 gap-4 p-fluid p-form-widget p-form-view-data p-form-aligned">
        <div class="col-span-6">
          <div class="field">
            <label data-test-id="npi-label">NPI: </label>
            <div class="p-field-value">
              <div class="readonly-field">
                {{ servicingFacilityNew.npi | emptyPlaceholder }}
              </div>
            </div>
          </div>
          <div class="field">
            <label data-test-id="servicing-facility-name">Servicing Facility Name: </label>
            <div class="p-field-value">
              <div class="readonly-field p-text-nowrap truncate">
                {{ servicingFacilityNew.facilityName | emptyPlaceholder }}
              </div>
            </div>
          </div>
          <div class="field">
            <label data-test-id="servicing-facility-tax-id">Tax ID: </label>
            <div class="p-field-value">
              <div class="readonly-field">
                {{ servicingFacilityNew.taxId | emptyPlaceholder }}
              </div>
            </div>
          </div>
          <div class="field">
            <label data-test-id="facility-phone-label">Phone: </label>
            <div class="p-field-value">
              <div class="readonly-field">
                {{ servicingFacilityNew.phone | phoneNumber }}
              </div>
            </div>
          </div>
          <div class="field">
            <label data-test-id="facility-fax-label">Fax: </label>
            <div class="p-field-value">
              <div class="readonly-field">
                {{ servicingFacilityNew.fax | phoneNumber }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-span-6">
          <div class="field">
            <label data-test-id="facility-street-label">Street: </label>
            <div class="p-field-value">
              <div class="readonly-field p-text-nowrap truncate">
                {{ servicingFacilityNew.address | emptyPlaceholder }}
              </div>
            </div>
          </div>
          <div class="field">
            <label data-test-id="facility-city-label">City: </label>
            <div class="p-field-value">
              <div class="readonly-field">
                {{ servicingFacilityNew.city | emptyPlaceholder }}
              </div>
            </div>
          </div>
          <div class="field">
            <label data-test-id="facility-state-label">State: </label>
            <div class="p-field-value">
              <div class="readonly-field">
                {{ servicingFacilityNew.state | emptyPlaceholder }}
              </div>
            </div>
          </div>
          <div class="field">
            <label data-test-id="facility-zip-code-label">ZIP Code: </label>
            <div class="p-field-value">
              <div class="readonly-field">
                {{ servicingFacilityNew.zipCode | zipCode | emptyPlaceholder }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </p-panel>
  </div>
}
